export default __webpack_public_path__ + "static/media/mPants_1_p1.e7a47cf7.jpeg";